import { throttle } from "lodash";
import { deferUntilNextFrame } from "../_helpers";

export default class PopUpModule {
  constructor() {
    const _this = this;

    if ($("[js-newsletter-popup]").length === 0) return;

    _this.popupDataKey = "popup_module";
    _this.turnstileCaptchaTokenKey = "captcha_token";
    _this.popupsArr = [];
    _this.captchaDone = false;
    _this.isPopupVisible = false;
    _this.siteKey = window.trunstileSiteKey;
    _this.secret = window.trunstileSecret;
    _this.turnstileVerifyUrl = window.trunstileSiteVerifyURL;

    _this.popupStatus = {
      enabled: "enabled", // default state
      complete: "complete", // form is filled by user
      disabled: "disabled"  // newsletter box closed by visitor
    };
  }

  init(elem) {
    const _this = this;

    // Display popup on user scroll by 100px from top
    window.addEventListener("scroll", throttle(_this.displayPopup.bind(this), 300));

    // Initialize popup for each element
    _this.popupId = $(elem).attr("data-popup-campaignId");

    _this.popup = $(`[data-popup-campaignId="${_this.popupId}"]`);
    _this.popupWrap = _this.popup.parents(".vbw-popup-wrap");
    _this.popupCampaign = _this.popup.attr("data-popup-campaignId");
    _this.newsletterUrl = _this.popup.attr("data-newsletter-url");
    _this.turnstileContainer = '#' + _this.popupCampaign;
    _this.newsletterProspect = _this.popup.attr("data-newsletter-prospect");
    _this.newsletterInput = _this.popup.find(".vbw-newsletter-email-input");
    _this.newsletterBtn = _this.popup.find(".vbw-newsletter-email-btn");

    // Newsletter popup close
    _this.popupWrap.on("click", function (e) {
      e.stopPropagation();
      const $elem = $(e.target);
      deferUntilNextFrame(() => {
        if ($elem.hasClass("vbw-popup-close") || $elem.hasClass("vbw-popup-wrap")) {
          const popupItem = _this.getPopupItem();
          if (popupItem.status != _this.popupStatus.complete) {
            popupItem.status = _this.popupStatus.disabled;
            _this.updatePopupData();
          }
          _this.isPopupVisible = false;
          _this.popupWrap?.hide();
        }
      });
    });
    // Email Validation
    _this.newsletterInput.on("keyup", function () {
      deferUntilNextFrame(() => {
        const inputValue = this.value;
        _this.validateEmail(inputValue);
      });
    });

    // Newsletter Submit
    _this.newsletterBtn.on("click", function () {
      deferUntilNextFrame(() => {
        const inputValue = _this.newsletterInput.val();
        if (_this.validateEmail(inputValue) && _this.validateCaptcha()) {
          const popupItem = _this.getPopupItem();
          popupItem.status = _this.popupStatus.complete;
          _this.updatePopupData();

          // Update image to submit data
          const newUrl = _this.newsletterUrl?.replace("{newsLetterEmail}", inputValue).replace("{newsletterProspect}", _this.newsletterProspect);
          $(".vbw-pixel-img-wrap").append(`<img src="${newUrl}" alt="newsletter image" />`);

          // newsletter submit success message
          $(".vbw-newsletter-email").addClass("submit-success");

          // hide input-btn section
          $(".vbw-popup-form-content").hide();
          $(".vbw-newsletter-wrap").show();
        }
      });
    });

    setTimeout(_this.readyTurnstileCaptcha(), 600);
  }

  readyTurnstileCaptcha() {
    const _this = this;
    turnstile.ready(function () {
      turnstile.render(_this.turnstileContainer, {
        sitekey: _this.siteKey,
        callback: function (token) {
          _this.captchaDone = false;
          const verifyURL = _this.turnstileVerifyUrl.replace('{token}', token);
          $.ajax({
            url: verifyURL,
            type: "GET",
            success: function (result) {
              let outcome = JSON.parse(result);
              if (outcome.success)
                _this.captchaDone = true;
              else
                turnstile.reset(_this.turnstileContainer)
            }
          });
        },
        'expired-callback': function () {
          _this.captchaDone = false;
        },
      });
    });
  }

  isEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  validateEmail(inputValue) {
    const _this = this;

    if ((!!inputValue && !_this.isEmail(inputValue)) || !inputValue) {
      $(".vbw-newsletter-email").addClass("email-validation-error");
      return false;
    }

    $(".vbw-newsletter-email").removeClass("email-validation-error");
    return true;
  }

  validateCaptcha() {
    const _this = this;
    if (!_this.captchaDone) {
      $(".vbw-newsletter-email").addClass("captcha-validation-error");
      return false;
    }

    $(".vbw-newsletter-email").removeClass("captcha-validation-error");
    return true;
  }

  isUserLoggedIn() {
    const token = getCookie('azureb2c_token');
    return token !== undefined;
  }

  isNewsletterSubscribed() {
    const consent = getCookie('azureb2c_extension_NewsLetter');
    return consent == "true";
  }

  isPopupStatusValid(status) {
    const _this = this;
    return status !== _this.popupStatus.complete && status !== _this.popupStatus.disabled;
  }

  isShowPopup() {
    const _this = this;
    const popupItem = _this.getPopupItem();

    // Is status valid
    if (!_this.isPopupStatusValid(popupItem.status)) {
      return false;
    }

    // Is logged in and newsletter not subscribed
    return !(_this.isUserLoggedIn() && _this.isNewsletterSubscribed());
  }

  getPopupItem() {
    const _this = this;
    const item = { id: _this.popupCampaign, status: _this.popupStatus.enabled };
    const localStoreData = localStorage.getItem(_this.popupDataKey);
    _this.popupsArr = localStoreData ? JSON.parse(localStoreData) : [];

    const popupItem = _this.popupsArr.find(x => x.id === _this.popupCampaign);

    if (popupItem) {
      return popupItem;
    }

    _this.popupsArr.push(item);
    _this.updatePopupData();
    return item;
  }

  displayPopup() {
    const _this = this;

    if (!_this.isPopupVisible && window.scrollY > 100 && _this.isShowPopup()) {
      _this.isPopupVisible = true;
      _this.popupWrap?.show();
      _this.popup?.show();

      window.removeEventListener("scroll", _this.displayPopup);
    }
  }

  updatePopupData() {
    const _this = this;
    localStorage.setItem(_this.popupDataKey, JSON.stringify(_this.popupsArr));
  }

}
